var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2250_3729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2252 10.7083C9.86686 9.55 11.1002 8.86667 11.8169 7.84167C12.5752 6.76667 12.1502 4.75833 10.0002 4.75833C8.59186 4.75833 7.9002 5.825 7.60853 6.70833L5.4502 5.8C6.04186 4.025 7.6502 2.5 9.99186 2.5C11.9502 2.5 13.2919 3.39167 13.9752 4.50833C14.5585 5.46667 14.9002 7.25833 14.0002 8.59167C13.0002 10.0667 12.0419 10.5167 11.5252 11.4667C11.3169 11.85 11.2335 12.1 11.2335 13.3333H8.8252C8.81686 12.6833 8.71686 11.625 9.2252 10.7083ZM11.6669 16.6667C11.6669 17.5833 10.9169 18.3333 10.0002 18.3333C9.08353 18.3333 8.33353 17.5833 8.33353 16.6667C8.33353 15.75 9.08353 15 10.0002 15C10.9169 15 11.6669 15.75 11.6669 16.6667Z",
    fill: "#4B475C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2250_3729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityQuestion);
export default __webpack_public_path__ + "static/media/security_question.a5fb03087d03e3032fb77f9b2f0d60e4.svg";
export { ForwardRef as ReactComponent };